import React, { useEffect, useRef } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import SearchBlueprintType from '../../../types/SearchBlueprintType';
import LoadingSpinner from '../../Spinner';

function SearchSimpleTable({
  searchBlueprint,
  height = '77vh',
  minHeight = 300,
  dataMapper,
  noResultsComponent,
  backgroundComponent
}) {
  const dispatch = useDispatch();
  const data = useSelector(searchBlueprint.selectData);
  const pageInfo = useSelector(searchBlueprint.selectPageInfo);
  const lastIndex = useSelector(searchBlueprint.selectLastIndex);
  const isLoading = useSelector(searchBlueprint.selectIsLoading);
  const isLengthAwarePagination = useSelector(searchBlueprint.selectIsLengthAwarePagination);
  const filters = useSelector(searchBlueprint.selectQuickFilterOptions);
  const scrollRef = useRef(null);

  const NoResults = noResultsComponent;
  const Background = backgroundComponent;

  useEffect(() => {
    if (scrollRef && scrollRef.current) {
      scrollRef.current.el.scrollTo(0, 0);
    }
  }, [filters]);

  if (isLoading) {
    return (
      <Box height={minHeight} mt="15rem">
        <LoadingSpinner isInline />
      </Box>
    );
  }

  if (!isLoading && !data.length) {
    return <NoResults />;
  }

  const pageData = isLengthAwarePagination
    ? { page: pageInfo.currentPage + 1 }
    : { after: lastIndex };

  return (
    <Box position="relative">
      <Box position="relative" zIndex={1}>
        <InfiniteScroll
          dataLength={data.length}
          hasMore={pageInfo.hasMore}
          height={height}
          loader={(<LoadingSpinner isInline />)}
          mt={4}
          next={() => dispatch(searchBlueprint.getPage(pageData))}
          onClick={e => e.stopPropagation()}
          ref={scrollRef}
          scrollThreshold={0.9}
        >
          {data.map(dataMapper)}
        </InfiniteScroll>
      </Box>
      <Box left="50%" position="absolute" top="50%" transform="translate(-50%, -50%)" zIndex={0}>
        <Background />
      </Box>
    </Box>
  );
}

SearchSimpleTable.propTypes = {
  /** Elasticsearch blueprint to use */
  searchBlueprint: SearchBlueprintType,
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dataMapper: PropTypes.func,
  noResultsComponent: PropTypes.func.isRequired,
  backgroundComponent: PropTypes.func
};

SearchSimpleTable.defaultProps = { backgroundComponent: () => <div /> };

export default SearchSimpleTable;
